import { lazy } from "react";
import { ACCESS_RIGHTS } from "@/constants/accessRights";

const Notifications = lazy(() => import("@/pages/Core/Notification/index"));
const Security_AuditLogs = lazy(() => import("@/pages/Security/AuditLogs/index"));
const Security_Roles = lazy(() => import("@/pages/Security/Roles/index"));
const Security_Users = lazy(() => import("@/pages/Security/Users/index"));
const Security_AccessRequests = lazy(() => import("@/pages/Security/AccessRequests/index"));

const Socials_FAQ = lazy(() => import("@/pages/Socials/FAQ/index"));
const Socials_Jobs = lazy(() => import("@/pages/Socials/Jobs"));
const Socials_Jobs_Details = lazy(() => import("@/pages/Socials/Jobs/Overview"));
const Socials_PrivacyPolicy = lazy(() => import("@/pages/Socials/PrivacyPolicy/index"));
const Socials_TermsAndConditions = lazy(() => import("@/pages/Socials/TermsAndConditions/index"));

export var coreRoutes = [
    { path: "/notifications", component: <Notifications />, permissionTypeId: [] },

    { path: "/security/users", component: <Security_Users />, permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_USERS] },
    { path: "/security/roles", component: <Security_Roles />, permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_ROLES] },
    { path: "/security/auditLogs", component: <Security_AuditLogs />, permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS] },
    {
        path: "/security/accessrequests",
        component: <Security_AccessRequests />,
        permissionTypeId: [
            ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
            ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
            ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
        ],
    },

    { path: "/socials/jobs", component: <Socials_Jobs /> },
    { path: "/socials/job-details", component: <Socials_Jobs_Details /> },
    { path: "/socials/faq", component: <Socials_FAQ /> },
    { path: "/socials/terms-conditions", component: <Socials_TermsAndConditions /> },
    { path: "/socials/privacy-policy", component: <Socials_PrivacyPolicy /> },
];